import { useResponsive, useToggle } from 'ahooks'
import { Modal } from 'antd'
import React from 'react'

import { useIsFeatureToggleOn } from '@/components/feature-toggle/feature-toggle.hooks'
import { useGetViewerQuery } from '@/generated/graphql'

import s from './onboarding.module.less'
import { OnboardingPages } from './pages/onboarding-pages.component'

export const OnboardingContainer: React.FC = () => {
  const [visible, { toggle }] = useToggle(false)
  const { data } = useGetViewerQuery()
  // 默认设置
  // {
  //   'xs': 0,
  //   'sm': 576,
  //   'md': 768,
  //   'lg': 992,
  //   'xl': 1200,
  // }
  const responsive = useResponsive()
  const isFeatureToggleOn = useIsFeatureToggleOn('onboarding')

  React.useEffect(() => {
    if (data && !data.viewer.hasOnboarding && isFeatureToggleOn) {
      toggle(true)
    }
  }, [data, isFeatureToggleOn])

  if (!data) {
    return null
  }

  const viewer = data.viewer

  return responsive['lg'] || responsive['xl'] ? (
    <Modal className={s.container} footer={null} width={950} closable={false} visible={visible} destroyOnClose>
      <OnboardingPages viewer={viewer} onModalClose={() => toggle(false)} />
    </Modal>
  ) : null
}
